import React from "react";

import { Form, Input, Button, Col, Row } from "antd";
import { v4 as uuidv4 } from "uuid";

function Dependents({ dependents, setDependents }) {
  const addDependent = () => {
    const newDependent = {
      id: uuidv4(),
      firstName: "",
      lastName: "",
      relationship: "",
      dateOfBirth: "",
    };
    setDependents([...dependents, newDependent]);
  };

  const removeDependent = (id) => {
    const updatedDependents = dependents.filter((item) => item.id !== id);
    setDependents(updatedDependents);
  };

  const handleChange = (value, name, id) => {
    const updatedDependent = dependents.map((item) => {
      if (item.id === id) {
        return { ...item, [name]: value };
      }
      return item;
    });
    setDependents(updatedDependent);
  };
  return (
    <ul>
      {dependents.map((item) => (
        <li key={item.id}>
          <Form.Item label="">
            <Row>
              <Col span={6}>
                <Form.Item
                  label=" "
                  rules={[
                    {
                      required: true,
                      message: "Please enter dependent first name!",
                    },
                  ]}
                >
                  <Input
                    onChange={(e) =>
                      handleChange(e.target.value, "firstName", item.id)
                    }
                  />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  label=" "
                  rules={[
                    {
                      required: true,
                      message: "Please enter dependent last name!",
                    },
                  ]}
                >
                  <Input
                    onChange={(e) =>
                      handleChange(e.target.value, "lastName", item.id)
                    }
                  />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item label=" ">
                  <Input
                    onChange={(e) =>
                      handleChange(e.target.value, "relationship", item.id)
                    }
                  />
                </Form.Item>
              </Col>
              <Col span={5}>
                <Form.Item label=" ">
                  <Input
                    placeholder="MM/DD/YYYY"
                    onChange={(e) =>
                      handleChange(e.target.value, "dateOfBirth", item.id)
                    }
                  />
                </Form.Item>
              </Col>
              <Col span={1}>
                {dependents.length > 1 ? (
                  <Button
                    className="roundSmallButton"
                    onClick={() => {
                      removeDependent(item.id);
                    }}
                    type="primary"
                    shape="circle"
                    icon={<i className="fa-sharp fa-solid fa-xmark"></i>}
                    size={"small"}
                  />
                ) : (
                  <></>
                )}
              </Col>
            </Row>
          </Form.Item>
        </li>
      ))}

      <Form.Item label="">
        <Button
          className="addPropertyGroupButton"
          type="primary"
          onClick={addDependent}
          size={"small"}
          icon={<i className="fa-solid fa-circle-plus"></i>}
    >
          Add Another Dependent
        </Button>
      </Form.Item>
    </ul>
  );
}

export default Dependents;
